import mediaProvider from '@/data-provider/mediaProvider';

export default {
  methods: {
    downloadMedia(id) {
      return mediaProvider.getMediaDownloadUrl(id);
    },
  },
};
